module.exports = __webpack_public_path__ + "static/media/candles made of chocolate.d61714ca.jpeg";